// src/hooks/useMediaQuery.ts
import { useEffect, useState } from "react";
function matchMedia(query) {
  if (typeof window === "undefined")
    return null;
  return window.matchMedia(query);
}
var useMediaQuery = (query) => {
  var _a;
  const [matches, setMatches] = useState((_a = matchMedia(query)) == null ? void 0 : _a.matches);
  useEffect(() => {
    const media = matchMedia(query);
    if (!media)
      return;
    if (media.matches !== matches)
      setMatches(media.matches);
    if (!media.addEventListener)
      return;
    const listener = () => {
      setMatches(media.matches);
    };
    media.addEventListener("change", listener);
    return () => {
      media.removeEventListener("change", listener);
    };
  }, [matches, query]);
  return matches;
};
var useMediaQuery_default = useMediaQuery;
export {
  useMediaQuery_default as default,
  useMediaQuery
};
//# sourceMappingURL=useMediaQuery.mjs.map